module.exports = __webpack_public_path__ + "static/media/online-teaching-img2.8b4a9078.jpg";